// extracted by mini-css-extract-plugin
export default {"construcao":"petshop_construcao__Z2J-i","texto":"petshop_texto__gEowH"};